import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

export const apiErrorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 502 || error.status === 504 || error.status === 503) {
        messageService.add({
          severity: 'error',
          detail: translateService.instant('notifications.apiError')
        });
      }
      if (error.status === 403) {
        messageService.add({
          severity: 'error',
          detail: translateService.instant('notifications.insufficientPermissions')
        });
      }
      return throwError(() => error);
    })
  );
};
